module.exports = __webpack_public_path__ + "img/Eriane.594df575.jpeg";